"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function ModalMessage(props) {
  var close = props.close,
    modalList = props.modalList,
    modalContent = props.modalContent,
    type = props.type,
    colorTheme = props.colorTheme;
  var _a = modalList || {},
    modalTitle = _a.modalTitle,
    btnConfiguration = _a.btnConfiguration;
  var _b = btnConfiguration || {},
    txt = _b.txt,
    href = _b.href,
    onCallback = _b.onCallback,
    extendProps = _b.extendProps;
  var modalBody = (0, _react.useRef)(null);
  var targetY = null;
  var sTop = null;
  var sH = null;
  var contentH = null;
  (0, _react.useEffect)(function () {
    var content = modalBody === null || modalBody === void 0 ? void 0 : modalBody.current;
    content === null || content === void 0 ? void 0 : content.addEventListener('touchstart', function (e) {
      targetY = Math.floor(e.targetTouches[0].clientY);
    });
    content === null || content === void 0 ? void 0 : content.addEventListener('touchmove', function (e) {
      var newTargetY = Math.floor(e.targetTouches[0].clientY);
      sTop = Math.ceil(content.scrollTop); // 当前滚动距离
      sH = Math.floor(content.scrollHeight); // 可滚动区域高度
      contentH = Math.floor(content.clientHeight); // 可视区域高度
      if (sTop <= 0 && newTargetY - targetY > 0) {
        e.preventDefault();
      } else if (sTop >= sH - contentH && newTargetY - targetY < 0) {
        e.preventDefault();
      }
    });
  }, []);
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: 'ant-modal-root new'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'ant-modal-mask'
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'ant-modal-wrap',
    onClick: function onClick() {
      if (close) {
        close();
      }
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'ant-modal'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'ant-modal-content',
    onClick: function onClick(e) {
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    "aria-label": "Close",
    className: "ant-modal-close",
    onClick: function onClick() {
      if (close) {
        close();
      }
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "ant-modal-close-x"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    role: "img",
    "aria-label": "close",
    className: "anticon anticon-close ant-modal-close-icon"
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6115 11.9743L5.29297 17.2928L6.70718 18.7071L12.0257 13.3885L17.34 18.7028L18.703 17.3399L13.3887 12.0256L18.7072 6.70706L17.293 5.29285L11.9745 10.6114L6.65594 5.29285L5.29297 6.65581L10.6115 11.9743Z",
    fill: "white"
  }))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('ant-modal-header-new', {
      'success-theme': type === 'success',
      'fail-theme': type === 'fail',
      'purple-theme': type === 'success' && colorTheme === 'purple',
      'blue-theme': type === 'success' && colorTheme === 'blue',
      'green-theme': type === 'success' && colorTheme === 'green',
      'pink-theme': type === 'success' && colorTheme === 'pink',
      'orange-theme': type === 'success' && colorTheme === 'orange'
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'ant-modal-title'
  }, modalTitle)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "ant-modal-body-new",
    dangerouslySetInnerHTML: {
      __html: modalContent || ''
    },
    ref: modalBody
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "ant-modal-footer-new"
  }, href && !onCallback ? ( /*#__PURE__*/_react["default"].createElement("a", __assign({
    className: 'ant-btn-new',
    href: href
  }, extendProps || {}, {
    onClick: function onClick() {
      if (close) {
        close();
      }
    }
  }), txt)) : ( /*#__PURE__*/_react["default"].createElement("button", __assign({
    type: "button",
    className: 'ant-btn-new',
    onClick: function onClick() {
      if (onCallback) {
        onCallback(txt);
      }
      if (close) {
        close();
      }
    }
  }, extendProps || {}), txt)))))));
}
var _default = exports["default"] = ModalMessage;